import {
  Box,
  Checkbox,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  tableBodyClasses,
  tableHeadClasses,
  tableRowClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

type TableHeadProps = {
  allowBorders: boolean;
  backgroundColor?: string;
};

type TableBodyProps = {
  allowBorders: boolean;
};

type GroupHeaderProps = {
  disablePadding: boolean;
};

export const CheckboxPadded = styled(Checkbox)({
  padding: 0,
  margin: 0,
  marginLeft: 1,
});

export const TableCellFixedWidth = styled(TableCell)({
  width: "70px",
  maxWidth: "70px",
  paddingLeft: "5px",
  paddingRight: "5px",
});

export const TableCellMedium = styled(TableCell)({
  width: "130px",
  maxWidth: "130px",
  paddingLeft: "5px",
  paddingRight: "5px",
});

export const TableCellWide = styled(TableCell)({
  width: "200px",
  maxWidth: "200px",
  paddingLeft: "5px",
  paddingRight: "5px",
});

export const TextContainerMedium = styled(Box)({
  display: "block",
  width: "140px",
  maxWidth: "140px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
});

export const TextContainer = styled(Box)({
  display: "block",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
});

export const TextContainerWide = styled(Box)({
  display: "block",
  width: "200px",
  maxWidth: "200px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
});

export const CellContentContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
});

export const TableHeader = styled(TableHead, {
  shouldForwardProp: (prop) =>
    prop !== "allowBorders" && prop !== "backgroundColor",
})<TableHeadProps>(({ allowBorders, backgroundColor }) => ({
  [`&.${tableHeadClasses.root} tr`]: {
    backgroundColor: backgroundColor || "#EAEAF1",
    ...(allowBorders
      ? {}
      : {
          [`&.${tableRowClasses.root} th`]: {
            border: "none",
          },
        }),
  },
  [`&.${tableHeadClasses.root} tr:nth-of-type(1)`]: {
    [`&.${tableRowClasses.root} th:nth-of-type(1)`]: {
      borderTopLeftRadius: "8px",
    },
    [`&.${tableRowClasses.root} th:last-child`]: {
      borderTopRightRadius: "8px",
    },
  },
}));

export const GroupedTableBody = styled(TableBody, {
  shouldForwardProp: (prop) => prop !== "allowBorders",
})<TableBodyProps>(({ allowBorders }) => ({
  ...(allowBorders
    ? {}
    : {
        [`&.${tableBodyClasses.root} tr`]: {
          [`&.${tableRowClasses.root} td`]: {
            border: "none",
          },
        },
      }),
}));

export const TableBodyItemBundle = styled(TableBody)({
  [`&.${tableBodyClasses.root} tr`]: {
    [`&.${tableRowClasses.root} td`]: {
      border: "none",
      backgroundColor: "rgba(162, 115, 225, 0.15)",
    },
  },
  [`&.${tableBodyClasses.root} tr:nth-of-type(1)`]: {
    [`&.${tableRowClasses.root} td:nth-of-type(1)`]: {
      borderTopLeftRadius: "10px",
    },
    [`&.${tableRowClasses.root} td:last-child`]: {
      borderTopRightRadius: "10px",
    },
  },
  [`&.${tableBodyClasses.root} tr:last-child`]: {
    [`&.${tableRowClasses.root} td`]: {
      borderBottom: "5px solid #F3F3F7",
    },
    [`&.${tableRowClasses.root} td:nth-of-type(1)`]: {
      borderBottomLeftRadius: "10px",
    },
    [`&.${tableRowClasses.root} td:last-child`]: {
      borderBottomRightRadius: "10px",
    },
  },
});

export const GroupHeader = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== "disablePadding",
})<GroupHeaderProps>(({ disablePadding }) => ({
  [`&.${tableRowClasses.root} td`]: {
    paddingTop: disablePadding ? "0px" : "5px",
    paddingBottom: disablePadding ? "0px" : "5px",
  },
}));
